<template>
  <div class="mt-1" v-if="canVerb(resource, 'index')">
    <actions-toolbar>
      <template #filters>
        <div class="status-filter">
          <div class="pill-wrapper my-3">
            <span
              class="pill"
              v-for="(value, name, index) in activeFilters"
              :key="index"
              data-color="white"
            >
              <span v-b-toggle.sidebar-1 :data-filter="name"
                ><strong>{{ sidebarFilterName(name) }}</strong
                >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
              >
              <span tabindex="0">
                <span
                  @click="resetSingleSidebarFilter(name)"
                  title="Rimuovi filtro"
                  >×</span
                >
              </span>
            </span>
            <template v-if="countActiveFilters">
              <span
                class="pill"
                data-color="alert"
                @click="resetAllFilters()"
                title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
              >
                <span
                  ><strong>Reset ({{ countActiveFilters }})</strong></span
                >
                <span><span>×</span></span>
              </span>
            </template>
          </div>
        </div>
      </template>
      <b-button-group
        v-b-toggle.sidebar-1
        :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
          countActiveFilters ? ' active' : ''
        }`"
        :title="getDefaultFilterMessage()"
      >
        <base-icon name="filters" width="23" height="23" />
        <span style="font-size: 14px; font-weight: 500">{{
          computedFilterTitle
        }}</span>
      </b-button-group>
      <b-button
        class="btn btn--create btn--smaller"
        type="button"
        variant="primary"
        size="sm"
        @click="onAddBookEntry"
        title="Crea un nuovo movimento"
        v-if="canVerb(resource, 'store')"
      >
        <base-icon name="circled_plus" width="22" height="22" />
        Crea
      </b-button>
    </actions-toolbar>
    <div class="table-container">
      <b-sidebar
        id="sidebar-1"
        :title="computedFilterTitle"
        :backdrop="true"
        width="50dvw"
        shadow
        right
        :visible="open_filter"
        :data-open="open_filter"
        @change="onSidebarFilterChange"
      >
        <template #header="{ hide }">
          <div class="inner-header">
            <template v-if="canVerb(resource, 'store')">
              <div class="inner-header--create">
                <strong class="mr-auto"> Crea un nuovo movimento </strong>
                <b-button
                  class="btn btn--create btn--smaller"
                  type="button"
                  variant="primary"
                  size="sm"
                  @click="onAddBookEntry"
                  title="Crea un nuovo movimento"
                  :disabled="!canVerb(resource, 'store')"
                >
                  <base-icon name="circled_plus" width="16" height="16" />
                  <span>Crea</span>
                </b-button>
              </div>
              <div class="inner-header--info">
                <strong class="mr-auto">
                  {{ computedFilterTitle }}
                </strong>
                <button class="close text-dark" @click="hide">
                  <b-icon icon="x"></b-icon>
                </button>
              </div>
            </template>
            <template v-else>
              <strong class="mr-auto">
                {{ computedFilterTitle }}
              </strong>
              <button class="close text-dark" @click="hide">
                <b-icon icon="x"></b-icon>
              </button>
            </template>
          </div>
        </template>
        <b-form @submit.prevent="onSearch(filterName)">
          <div class="filter">
            <div class="filter-item">
              <base-select
                name="cod_prod"
                label="Produttore"
                :options="salesmen_select"
                v-model="filter.byBroker.id"
                :multiple="true"
                :closeOnSelect="false"
                :taggable="salesmen_taggable"
                :defaultHtmlMultipleSelect="true"
                @changeTaggable="changeTaggable"
              >
                <template #advanced-actions>
                  <b-button
                    :pressed.sync="myToggle"
                    variant="light"
                    class="btn--smaller btn--x-smaller btn--transparent"
                    @click="myToggle ? selectAllBrokers() : deselectAllBrokers()"
                    >{{ myToggle ? "Deseleziona tutti" : "Seleziona tutti" }}
                  </b-button>
                  <b-button
                    :pressed.sync="myTogglePO"
                    variant="light"
                    class="btn--smaller btn--x-smaller btn--transparent"
                    @click="
                      myTogglePO ? salesmenOrderByCode() : salesmenOrderByName()
                    "
                    >{{ myTogglePO ? "Ordine per nome" : "Ordina per codice" }}
                  </b-button>
                </template>
              </base-select>
            </div>
            <div class="filter-item" data-cols="2">
              <base-datepicker
                name="book_date"
                label="Data Registrazione Dal"
                v-model="filter.byCalendar.from"
              />
              <base-datepicker
                name="book_date"
                label="Data Registrazione al"
                v-model="filter.byCalendar.to"
              />
            </div>
          </div>
          <div class="actions-filter-sidebar-wrapper">
            <b-button
              type="submit"
              variant="lisaweb"
              size="sm"
              v-b-toggle:sidebar-1
              >Cerca
            </b-button>
            <b-button
              class="btn--transparent btn-reset"
              type="button"
              size="sm"
              @click="onClearFilter(filterName)"
              >Reset
            </b-button>
          </div>
        </b-form>
      </b-sidebar>
      <salesmen-book-entry
        @edit="onEdit"
        @destroy="onDestroy"
        @manualFetch="manualFetch"
        :fields="fields"
        :repository="repository"
        :resource="resource"
        :performedSearch="computePerformedSearch"
        :filterCount="countActiveFilters"
        :filterOn="{
          byRelations: [
            'byBroker',
            'byDocument',
            'byTask',
            'byRegistry',
            'byInsurer',
            'byInsuranceAncillary',
            'byVariousAccounting',
            'byBookTag',
          ],
        }"
        :filterName="filterName"
        :ref="tableRef"
        :onlyActions="['destroy', 'edit']"
      ></salesmen-book-entry>
    </div>
  </div>
  <div v-else class="mt-3">
    <b-icon icon="info-circle" scale="1.00"></b-icon>
    Non hai i permessi
  </div>
</template>

<script>
import SalesmenBookEntry from "@/components/tables/SalesmenBookEntry";
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import BaseSelect from "@/components/form/BaseSelect";
import BaseDatepicker from "@/components/form/BaseDatepicker";
import { mapGetters, mapActions } from "vuex";
import { toLocaleDate } from "@/utils/dates";
import { toLocaleCurrency } from "@/utils/strings";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import BaseIcon from "@/components/BaseIcon";
import SidebarFilterMixin from "../../../../mixins/SidebarFilterMixin";

export default {
  mixins: [CustomFiltersMixin, SidebarFilterMixin],
  data() {
    return {
      filter: this.initFilter(),
      filterName: "filterSalesmenBookEntry",
      resource: "book_entries",
      repository: "book_entry",
      tableRef: "SalesmenBookEntryTableRef",
      salesmen: [],
      myToggle: false,
      myTogglePO: false,
      salesmen_ordered: [],
      salesmen_select: [],
      salesmen_ids: [], // i produttori della tendina multipla
      salesman_id: null,
      activeFilters: {},
      performedSearch: false,
      salesmen_taggable: true,
      fields: [
        {
          key: "broker",
          label: this.getDictionary("broker", "book_entry"),
        },
        {
          key: "book_date",
          label: this.getDictionary("book_date", "book_entry"),
          formatter: (value) => toLocaleDate(value),
        },
        {
          key: "title",
          label: this.getDictionary("title", "book_entry"),
        },
        {
          key: "gross",
          label: "Premio",
          sortable: false,
          formatter: (value) => toLocaleCurrency(value),
          thClass: "text-right",
          thStyle: {
            "text-align": "right",
          },
          tdClass: "text-right",
        },
        {
          key: "net",
          label: this.getDictionary("net", "book_entry"),
          sortable: false,
          formatter: (value) => toLocaleCurrency(value),
          thClass: "text-right",
          thStyle: {
            "text-align": "right",
          },
          tdClass: "text-right",
        },
        {
          key: "saler_prov_take",
          label: "Provv.Acq.Prod",
          sortable: false,
          formatter: (value) => toLocaleCurrency(value),
          thClass: "text-right",
          thStyle: {
            "text-align": "right",
          },
          tdClass: "text-right",
        },
      ],
    };
  },
  components: {
    BaseIcon,
    // ButtonGroupTable,
    BaseSelect,
    BaseDatepicker,
    SalesmenBookEntry,
  },
  computed: {
    countActiveFilters() {
      console.log("COUNT ACT FILTERS", Object.keys(this.activeFilters));
      return Object.keys(this.activeFilters).length;
    },
    computePerformedSearch() {
      return this.performedSearch;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
  },
  methods: {
    changeTaggable(val) {
      this.salesmen_taggable = val;
    },
    manualFetch() {
      this.resetAllFilters();
    },
    initFilter() {
      let init = {
        byBroker: {
          id: null,
        },
        byCalendar: {
          from: null,
          to: null,
        },
        byVariousAccounting: {
          id: 2,
        },
      };
      return init;
    },
    onAddBookEntry() {
      // have to open the "salesmen" variant of book_entries create
      this.$router.push({
        name: `book_entries.create`,
        params: { mode: "II" },
      });
    },
    onEdit(item) {
      this.$router.push({
        name: `${this.resource}.edit`,
        params: { id: `${item.id}`, item: item, mode: "II" },
      });
    },
    onDestroy(id) {
      const Repo = RepositoryFactory.get(this.repository);
      Repo.destroy(id)
        .then(() => {
          // console.debug("successfully deleted!");
          this.$refs[this.tableRef].fetch();
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    salesmenOrderByName() {
      this.salesmen_select = this.salesmen;
    },
    salesmenOrderByCode() {
      this.salesmen_select = this.salesmen_ordered;
    },
    selectAllBrokers() {
      this.filter.byBroker.id = this.getSalesmen().map(
        (cooperator) => cooperator.value,
      );
    },
    deselectAllBrokers() {
      this.filter.byBroker.id = [];
      this.salesman_id = null;
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }
      delete this.activeFilters["byVariousAccounting.id"];
      return this.activeFilters;
    },
    onSearch(name) {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      this.removePaginationByName(name);
      this.$refs[this.tableRef].currentPage = 1;
      this.$refs[this.tableRef].fetch();
    },
    onClearFilter(name) {
      this.resetFilter();
      this.resetPagination();
      this.removeFilterByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      this.$refs[this.tableRef].sortBy = "";
      this.$refs[this.tableRef].sortDesc = false;
      // this.onSearch(name);
    },
    onSaveFilter(name, criteria) {
      this.saveFilterByName({ name, criteria });
    },
    customFilterName(key, prefix = "byAttribute") {
      return `${prefix}.${key}`;
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
    }),
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
    ...mapGetters("auth", {
      getSalesmen: "salesmen",
      getSalesmenOrderedByCode: "salesmen_orderd_by_code",
    }),
  },
  beforeMount() {
    this.salesmen = this.getSalesmen();
    this.salesmen_ordered = this.getSalesmenOrderedByCode();
    this.salesmen_select = this.salesmen;
  },
};
</script>
